import React, { ReactElement, useContext } from 'react'
import { isEmpty } from 'lodash'
import { useRouter } from 'next/router'
import { IButtons, getSocialButtons } from './utils'
import { SocialButton } from '../SocialButton/SocialButton'
import styles from './SocialNetworksAuthButtons.module.css'
import { getAppId } from '../../utils/appId'
import { LocaleContext } from '../LocaleContext/LocaleContext'
import { SocialNetworkCode, SocialNetworks } from '../../emun/social'
import { Languages } from '../../interfaces/common'
import { GoogleIcon } from './components/GoogleIcon'
import { VkIcon } from './components/VkIcon'
import { MailIcon } from './components/MailIcon'
import { OkIcon } from './components/OkIcon'
import { FbIcon } from './components/FbIcon'
import { YandexIcon } from './components/YandexIcon'
import { getQueryParam } from '../../utils/getQueryParam'
import { parseSearchParams } from '../../utils/searchParams'

const socialNetworkImageMap: Record<SocialNetworkCode, ReactElement> = {
  [SocialNetworkCode.Vk]: <VkIcon />,
  [SocialNetworkCode.Google]: <GoogleIcon />,
  [SocialNetworkCode.Mail]: <MailIcon />,
  [SocialNetworkCode.Ok]: <OkIcon />,
  [SocialNetworkCode.Facebook]: <FbIcon />,
  [SocialNetworkCode.Yandex]: <YandexIcon />,
}

interface IAuthSocialProps {
  selectedItems?: Array<SocialNetworks>
  onSocialAuth(socialNetwork: SocialNetworks, callbackUrl?: string, appId?: number, lang?: string): void
  language?: Languages
}

export const SocialNetworksAuthButtons: React.FC<IAuthSocialProps> = ({ selectedItems, onSocialAuth, language }) => {
  const { locale } = useContext(LocaleContext)
  const { query } = useRouter()
  const callbackurl = getQueryParam(query, 'callbackurl')
  const reglink = getQueryParam(query, 'reglink')
  const lang = getQueryParam(query, 'lang')

  const buttons = React.useMemo(() => {
    const socialButtons = getSocialButtons(styles)

    if (selectedItems) {
      const selectedSocialButtons: Array<IButtons> = []

      socialButtons.forEach((socialButton: IButtons) => {
        if (selectedItems.map((item) => item.toUpperCase()).includes(socialButton.id)) {
          selectedSocialButtons.push(socialButton)
        }
      })

      return selectedSocialButtons
    }

    return socialButtons
  }, [selectedItems])

  const callbackUrl = !isEmpty(callbackurl) ? callbackurl : parseSearchParams(reglink ?? '')?.callbackurl

  return (
    <div className={styles.wrapper}>
      {buttons.map(({ id, code, langs, dataQaLocator }) => {
        if (!langs.some((lang) => lang === locale)) {
          return null
        }

        return (
          <SocialButton
            key={id}
            className={styles.button}
            data-qa-locator={dataQaLocator}
            onClick={() => {
              onSocialAuth(id, callbackUrl, getAppId(query), language ?? lang ?? '')
            }}
          >
            {socialNetworkImageMap[code]}
          </SocialButton>
        )
      })}
    </div>
  )
}

SocialNetworksAuthButtons.displayName = 'SocialNetworksAuthButtons'
